export const animatedBrandTitle = () => {
	const brandTitleElement: any = document.getElementById('brand-title')
	let brandTitle = '<span class="persist">S</span>'
	brandTitle += '<span class="disappear">ubhendu Ku</span>'
	brandTitle += '<span class="persist">mar</span>'
	brandTitle += '<span class="disappear"> Saho</span>'
	brandTitle += '<span class="persist">o</span>'
	brandTitle += '<span id="last"></span>'
	brandTitleElement.innerHTML = brandTitle

	const persistElement: any = document.getElementsByClassName('persist')
	const disappearElement: any = document.getElementsByClassName('disappear')
	const lastElement: any = document.getElementById('last')
	lastElement.style.opacity = 0

	setTimeout(() => {
		Array.from(persistElement).forEach((item: any) => {
			item.style.color = '#FCF803'
		})
		Array.from(disappearElement).forEach((item: any) => {
			item.style.opacity = 1
			let initialOpacity = 1
			const opacity = setInterval(() => {
				if (initialOpacity > 0) {
					initialOpacity -= 0.05
					item.style.opacity = initialOpacity
				}
			}, 100)
			setTimeout(() => clearInterval(opacity), 2000)
		})
	}, 2000)

	setTimeout(
		() =>
			Array.from(disappearElement).forEach((item: any, index: any) => {
				const currentText = item.innerText
				currentText.split('').forEach((char: any, charIndex: any) => {
					setTimeout(() => {
						item.innerText = currentText.slice(charIndex, currentText.length - 1)
						lastElement.innerText += char === ' ' ? '\xa0' : char
					}, charIndex * (index + 1) * 100)
				})
			}),
		4200
	)

	setTimeout(() => animatedBrandTitle(), 6000)
}
